var _rect, _circle, _path, _circle2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg3DSecure = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 96,
    height: 96,
    rx: 48,
    fill: "#7B66F2",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.4998,
    cy: 48,
    r: 35.2,
    fill: "#7B66F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4993 48.0655V37.2921C67.4993 37.0698 67.3643 36.8686 67.1558 36.7804L67.0316 36.7277C60.3948 33.9273 54.1205 30.3635 48.3407 26.1115C48.1388 25.9628 47.8608 25.9628 47.6589 26.1115C41.8787 30.3631 35.6044 33.9263 28.968 36.7277L28.8435 36.7804C28.6347 36.8682 28.4997 37.0698 28.5 37.2921V48.0655C28.5 51.8296 29.5071 55.3294 31.4922 58.4667C33.0737 60.966 35.2748 63.2379 38.0345 65.2193C42.712 68.5776 47.3184 69.9222 47.5123 69.9778C47.6148 70.0069 47.7234 70.0075 47.8259 69.9791C48.0261 69.9235 52.7906 68.5802 57.6292 65.2248C60.4847 63.2444 62.7628 60.9731 64.4001 58.4742L64.4004 58.4745C66.445 55.3755 67.5227 51.7575 67.4996 48.0658L67.4993 48.0655ZM63.4545 57.8563C61.9009 60.2322 59.7294 62.3987 57.0004 64.2957C52.7985 67.2163 48.5377 68.5978 47.6743 68.8598C46.8309 68.5943 42.7258 67.2131 38.6779 64.3C36.0434 62.4045 33.9471 60.2383 32.4473 57.8631C30.5818 54.9085 29.6359 51.6123 29.6359 48.0648L29.6355 37.6587C36.1433 34.8925 42.3055 31.4007 47.9993 27.2525C53.6935 31.4004 59.8557 34.8922 66.3639 37.6587V48.0648C66.3853 51.5368 65.3739 54.9395 63.454 57.8565L63.4545 57.8563Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 48,
    r: 7.5,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6202 44.1146C51.7691 43.9618 52.0104 43.9618 52.1593 44.1146C52.3082 44.2675 52.3082 44.5153 52.1593 44.6682L45.1508 51.8642C45.0019 52.0171 44.7605 52.0171 44.6117 51.8642C44.4628 51.7114 44.4628 51.4635 44.6117 51.3107L51.6202 44.1146Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3883 51.3318C52.5372 51.4847 52.5372 51.7325 52.3883 51.8854C52.2395 52.0382 51.9981 52.0382 51.8492 51.8854L44.8407 44.6893C44.6918 44.5365 44.6918 44.2886 44.8407 44.1358C44.9896 43.9829 45.2309 43.9829 45.3798 44.1358L52.3883 51.3318Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(Svg3DSecure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/3d-secure.726f54e43a73fb8b5474b47d2e4c2afd.svg";